module.exports = __webpack_public_path__ + "static/img/left-pic.6524e359.png";